import { Alert, RichText } from '@ads-core/components';
import { QueryStatus } from '@tanstack/react-query';

type FilterAlertsProps = {
  errorMessage?: string;
  hasResults?: boolean;
  isOperational?: boolean;
  noResultsMessage?: string;
  status?: QueryStatus;
  isLoading?: boolean;
};

/**
 * Returns a message for the Alert Component.
 * @param status
 * @param isOperational
 * @param hasOutages
 * @returns string | undefined
 */
const filterAlerts = ({
  status,
  isOperational,
  hasResults,
  noResultsMessage,
  errorMessage,
}: FilterAlertsProps) => {
  switch (true) {
    case status === 'error':
      return errorMessage ?? 'Er is een fout opgetreden bij het laden van de resultaten';
    case isOperational === false:
      return 'We zien aan uw postcode dat Liander niet uw netbeheerder is. Controleer uw gegevens of zoek uw netbeheerder op via <a href="https://www.mijnaansluiting.nl/netbeheerders" rel="noopener noreferrer" target="_blank"> mijnaansluiting.nl</a>.';
    case hasResults === false:
      return noResultsMessage ?? 'Er zijn geen resultaten gevonden';
    default:
      return undefined;
  }
};

export const Alerts = ({
  hasResults,
  isOperational,
  status,
  noResultsMessage,
  errorMessage,
  isLoading,
}: FilterAlertsProps) => {
  const message = filterAlerts({
    hasResults,
    isOperational,
    status,
    noResultsMessage,
    errorMessage,
  });

  return (
    <Alert variant={status === 'error' ? 'error' : 'info'}>
      {message && !isLoading ? <RichText>{message}</RichText> : null}
    </Alert>
  );
};
